import { createAsyncActionType } from './index';

export const FAVOURITE_LIST_GET = createAsyncActionType('favourite', 'FAVOURITE_LIST_GET');
export const SET_FAVOURITE = createAsyncActionType('favourite', 'SET_FAVOURITE');
